import { FOCUS_TRAP_SELECTOR } from './constants';
import handleFocusBackwards from './handleFocusBackwards';
import handleFocusForwards from './handleFocusForwards';
const FOCUSABLE_ELEMENT_SELECTORS = '[href], button:not([disabled]), [tabindex="0"]';
const handleArrowKey = ({ current, key, isArrowKeyNavigationActivated }, name) => {
    const dialogs = document.querySelectorAll(`${FOCUS_TRAP_SELECTOR}[data-modal-name=${name}]`);
    const isCurrentActiveDialog = dialogs[dialogs.length - 1] === current;
    if (current &&
        isCurrentActiveDialog &&
        isArrowKeyNavigationActivated &&
        (key === 'ArrowDown' || key === 'ArrowUp')) {
        const currentActiveElement = document.activeElement;
        const focusableElements = current.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS);
        const HTMLFocusableElements = [];
        focusableElements.forEach((el) => {
            if (el instanceof HTMLElement) {
                HTMLFocusableElements.push(el);
            }
        });
        const currentActiveElementIndex = HTMLFocusableElements.findIndex((element) => element === currentActiveElement);
        if (key === 'ArrowDown') {
            return handleFocusForwards(HTMLFocusableElements, currentActiveElementIndex);
        }
        return handleFocusBackwards(HTMLFocusableElements, currentActiveElementIndex);
    }
    return undefined;
};
export default handleArrowKey;
//# sourceMappingURL=handleArrowKey.js.map